import { CSSProperties, useLayoutEffect } from 'react';
import { useResizeObserver } from '../hooks';
import * as React from 'react';

export interface Dimensions {
   width?: number,
   height?: number
}

export interface ResizeObserverProps {
   onDimensionsChange?: (dimensions: Dimensions) => void,
   onWidthChange?: (width: number) => void,
   onHeightChange?: (height: number) => void,
   style?: CSSProperties
   className?: string;
}

export const ResizeObserver = (props: React.PropsWithChildren<ResizeObserverProps>) => {

   const [dimensionsRef, dimensions] = useResizeObserver();

   useLayoutEffect(() => {

      if (dimensions) {

         if (dimensions.width && props.onWidthChange) {
            props.onWidthChange(dimensions.width);
         }

         if (dimensions.height && props.onHeightChange) {
            props.onHeightChange(dimensions.height);
         }

         if ((dimensions.width || dimensions.height) && props.onDimensionsChange) {
            props.onDimensionsChange(dimensions);
         }
      }
   }, [dimensions]);

   const style = {
      ...props.style
   }

   return (<div ref={dimensionsRef} style={style} className={props.className}>
      {props.children}
   </div>);
}
